<template>
  <div v-if="isLoadedTranslates"
       id="app"
       class="page">
    <div
      class="page__header-with-content"
      :class="{ '_screen-height': $route.meta.footerUnderScreen }"
    >
      <CookieMsg/>
      <TheHeader v-if="!$route.meta.withoutHeader"
                 @onBellClick="onBellClick"/>

      <YourResumeIsNotCompletedNotification v-if="showResumeNotCompletedNotification" :key="$route.fullPath" />
      <YouHaveInteractionStartedNotification v-else-if="showInteractionNotification"/>
      <EmployerFirstStepsStepsPreview v-if="isEmployer && employerChecklist && !employerChecklist.employer_first_steps_showed"/>

      <router-view @hook:mounted="onPageMounted"
                   @hook:beforeRouteUpdate="onPageMounted"
                   class="page__main"/>
    </div>

    <TheFooter v-if="!$route.meta.withoutFooter"/>
    <TheSvgList/>
    <TheFixedSidebar v-if="isLogged" ref="sidebar"/>
  </div>
</template>

<script>
  import {EMPLOYEE} from '../constants/usersTypes'
  import TheHeader from '../components/TheHeader'
  import TheFooter from '../components/TheFooter'
  import TheSvgList from '../components/TheSvgList'
  import TheFixedSidebar from '../components/TheFixedSidebar'
  import CookieMsg from '../components/CookieMsg'
  import YouHaveInteractionStartedNotification from '../components/YouHaveInteractionStartedNotification'
  import YourResumeIsNotCompletedNotification from '../components/YourResumeIsNotCompletedNotification'
  import EmployerFirstStepsStepsPreview from '../components/EmployerFirstStepsStepsPreview'
  import {mapGetters, mapState} from 'vuex'

  export default {
    components: {
      TheHeader,
      TheFooter,
      TheSvgList,
      TheFixedSidebar,
      CookieMsg,
      YouHaveInteractionStartedNotification,
      YourResumeIsNotCompletedNotification,
      EmployerFirstStepsStepsPreview,
    },
    data() {
      return {
        scrollPosition: null
      }
    },
    computed: {
      ...mapState('user', [
        'cookieMsg',
        'profile',
        'resumeCompleted',
        'resume',
        'employerChecklist',
      ]),
      ...mapGetters('user', [
        'isLogged',
        'hasInteraction',
        'isEmployer',
      ]),
      isLoadedTranslates() {
        return this.$store.state.translates._loaded
      },
      showInteractionNotification() {
        return this.hasInteraction
          && this.$get(this.profile, 'user_type') === EMPLOYEE
          && !this.isRouteNameMixin('account-interaction')
      },
      showResumeNotCompletedNotification() {
        const responseOnAdditionalQuestionsName = 'response-additional-questions';
        const skipPages = [responseOnAdditionalQuestionsName, responseOnAdditionalQuestionsName + '-double'];

        return this.resume && !this.resumeCompleted && !skipPages.includes(this.$route.name);
      },
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
    },
    methods: {
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      onPageMounted() {
        const hash = this.$route.hash
        if (!hash) return
        this.$scrollTo(hash)
      },
      onBellClick() {
        this.$refs['sidebar'].onOpenSidebar('notifications')
      }
    },
    watch: {
      '$route.hash'() {
        this.onPageMounted()
      }
    }
  }
</script>

<style lang="less">

</style>
